/**
 * Bestandswerte für den Rich-Text-Editor aufbereiten.
 *
 * Felder, die von `textarea` auf `richtext` umgestellt wurden, enthalten noch
 * reinen Text mit echten Zeilenumbrüchen. Der Editor schreibt seinen Wert per
 * innerHTML — ohne Umwandlung stünde so ein Text einzeilig im Editor und wäre
 * beim ersten Speichern endgültig ohne Absätze.
 *
 * Die Website macht dieselbe Umwandlung beim Rendern (website/lib/safeHtml.ts),
 * die Darstellung bleibt dadurch vor und nach dem ersten Speichern gleich.
 */

const hasHtmlMarkup = (input: string): boolean => /<\/?[a-z][\s\S]*>/i.test(input);

// Bewusst ohne replaceAll — das tsconfig-Target der Office-App ist aelter.
const escapeHtml = (input: string): string =>
  input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

/** Reintext zu Absätzen; alles mit Markup bleibt unangetastet. */
export function toRichTextHtml(value: string | null | undefined): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  if (hasHtmlMarkup(raw)) return raw;

  return raw
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
    .join('');
}
